import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { IHttpRequestOptions } from '../../interfaces/http-request-option.interface';
import { HttpWrapperService } from '../http-wrapper.service';
import { StorytellerData } from '../../interfaces/storyteller.interface';

@Injectable({
  providedIn: 'root'
})
export class StorytellerService {

  constructor(private readonly httpWrapperService: HttpWrapperService) { }

    getStorytellerData(id: number): Observable<StorytellerData[]> {
      const url = `storyteller/${id}`;
      const options: IHttpRequestOptions = {
        url: url,
      };
      return this.httpWrapperService.getFromApiGateWay(options).pipe(
        map((response: StorytellerData[]) => response)
      );
    }
}